export default __webpack_public_path__ + "static/media/payment-success.1992df11.svg";